var commonServerErrorResponses = {
  parameterParseError: 'parameter_parse_error'
}

/**
 * in API  objectsNotFound is de facto error status but is sent when e.g response collection is empty
 * so it isn't error at all
 */
var commonServerSuccessResponses = {
  ok: 'ok',
  objectsNotFound: 'no_objects_found'
}

var validationMessages = {
  ok: 'ok',
  error: 'error',
  invalidAction: 'invalidAction'
}

let initServerConnectorConstants = function(module) {
  module.constant('COMMON_SERVER_SUCCESS_RESPONSES', commonServerSuccessResponses);
  module.constant('COMMON_SERVER_ERROR_RESPONSES', commonServerErrorResponses);
  module.constant('VALIDATION_MESSAGES', validationMessages);
};
  
export default initServerConnectorConstants;


// WEBPACK FOOTER //
// ./src/service/server-connector/constants.js